import classNames from "classnames";
import { observer } from "mobx-react-lite";
import moment from "moment";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Row,
} from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { IUserMeeting } from "../../app/models/meeting";
import { RootStoreContext } from "../../app/stores/rootStore";

interface IParams {
  meeting: IUserMeeting;
}

const OfflineMeetingCard: React.FC<IParams> = ({ meeting }) => {
  const rootStore = useContext(RootStoreContext);
  const startDateObj = moment(meeting.startDate);
  const endDateObj = moment(meeting.endDate);
  const link = `meeting/${meeting.id}`;
  const { theme, companyTheme } = rootStore.commonStore;
  const [t] = useTranslation(["translation"], translationHookOptions);

  return (
    <div className="mt-4">
      <Card
        className={classNames(
          "meetingCard",
          `${theme?.meetingCardOfflineColor} ${theme?.meetingCardOfflineBorderColor}`
        )}
      >
        <CardHeader className="meetingCardHeaderFooter">
          <br></br>
        </CardHeader>
        <CardBody className="meetingCardBody">
          <Row
            className={classNames(
              "justify-content-center mb-2",
              `${theme?.meetingCardFutureTextColor}`
            )}
          >
            <h5>
              {" "}
              <b>{meeting.title}</b>
            </h5>
          </Row>
          <Row
            className={classNames(
              "justify-content-center ",
              `${theme?.meetingCardFutureTextColor}`
            )}
          >
            <h6>
              <b>{startDateObj.format("DD.MM.YYYY")}</b>
            </h6>
          </Row>
          <Row
            className={classNames(
              "justify-content-center ",
              `${theme?.meetingCardFutureTextColor}`
            )}
          >
            {companyTheme?.hiddenEndHour ? (
              <h6>
                {t("meeting_card_startonly", {
                  start_time: startDateObj.format("HH:mm"),
                })}
              </h6>
            ) : (
              <h6>
                {t("meeting_card_startend", {
                  start_time: startDateObj.format("HH:mm"),
                  end_time: endDateObj.format("HH:mm"),
                })}
              </h6>
            )}
          </Row>
        </CardBody>
        <CardFooter className="meetingCardHeaderFooter">
          <Link to={link}>
            <Button
              className={classNames(
                "meetingCardButton",
                `${theme!.meetingCardFutureButtonColor} ${
                  theme!.meetingCardFutureButtonTextColor
                }`
              )}
            >
              {t("meeting_card_doc_num", { doc_num: meeting.documentsCount })}
            </Button>
          </Link>
        </CardFooter>
      </Card>
    </div>
  );
};

export default observer(OfflineMeetingCard);
